export default __webpack_public_path__ + "static/media/hbs-k-cbb-4.66b349d3.png";